import classNames from "classnames/bind";
import React, { FocusEventHandler, useState } from "react";

import { DropdownMenuItem as MenuItem } from "../../components/dropdown-menus/dropdown-menu-items/dropdown-menu-item-interface";
import { DropdownMenu } from "../dropdown-menus/dropdown-menu";
import { KIND, SIZE, SIZES } from "../dropdown-menus/dropdown-menu.constants";
import styles from "./dropdownInput.module.scss";

const cx = classNames.bind(styles);

export interface Props {
    kind: KIND;
    placeholder: string;
    size: SIZE;
    dropdownMenuItems: Array<MenuItem>;
    onClick?: (item: MenuItem) => void;
    dropdownOnly?: boolean;
}

export const DropdownInput: React.FC<Props> = (props: Props) => {
    const { kind, dropdownMenuItems, placeholder, size, onClick, dropdownOnly } = props;
    const [isFilled, setIsFilled] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const inputWrapperClassName = cx({
        [styles.inputWrapper]: true,
    });

    const inputDropdownClassName = cx({
        [styles.inputDropdown]: true,
        [styles.filled]: isFilled && isFilled === true,
        [styles[size]]: size === SIZES.SMALL,
        [styles.noZoomInput]: dropdownOnly === false,
    });

    const onChange = ({ target: { value } }): void => {
        setIsFilled(!!value);
    };

    const onFocus: FocusEventHandler = () => {
        setIsActive(true);
    };

    const onBlur: FocusEventHandler = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
            setIsActive(false);
        }
    };

    const dropdownMenuStyles = cx({
        [styles.dropdownMenuContainer]: true,
        [styles.dropdownMenuContainerShow]: isActive,
    });

    const dropdownButton = (
        <button
            className={inputDropdownClassName}
            onClick={() => {
                setIsFilled(!isFilled);
                setIsActive(!isActive);
            }}
            data-testid="dropdown-input"
        >
            {placeholder}
        </button>
    );

    const dropdownInput = (
        <input
            className={inputDropdownClassName}
            onChange={onChange}
            placeholder={placeholder}
            type="text"
            onFocus={onFocus}
            data-testid="dropdown-input"
        />
    );

    return (
        <div className={inputWrapperClassName} onBlur={onBlur}>
            {dropdownOnly ? dropdownButton : dropdownInput}
            <div className={dropdownMenuStyles}>
                <DropdownMenu
                    dropdownMenuItems={dropdownMenuItems}
                    size={size}
                    kind={kind}
                    onClick={(item: MenuItem) => {
                        setIsActive(false);
                        onClick(item);
                    }}
                />
            </div>
        </div>
    );
};
